import { ArrowRight, Cloud, Database, Gauge, GitBranch, ServerCog, ShieldCheck } from 'lucide-react';
import { ContactForm } from '../features/contacts/ContactForm.jsx';
import { PostList } from '../features/posts/PostList.jsx';
import { ProfileSummary } from '../features/profile/ProfileSummary.jsx';
import { projects } from '../data/projects.js';

const strengths = [
  { icon: ServerCog, title: 'APIs mantenibles', text: 'Contratos claros, versionado y manejo consistente de errores.' },
  { icon: Database, title: 'Datos y rendimiento', text: 'Modelado, consultas eficientes, cache y lectura de metricas.' },
  { icon: Cloud, title: 'Cloud ready', text: 'Arquitecturas listas para CI/CD, CDN, observabilidad y despliegue estatico.' },
  { icon: ShieldCheck, title: 'Buenas practicas', text: 'Seguridad, testing, documentacion tecnica y revisiones con criterio.' },
];

export function HomePage() {
  return (
    <>
      <section className="hero" id="inicio">
        <div className="hero-content">
          <p className="eyebrow">Backend developer | APIs | Cloud | Sistemas escalables</p>
          <h1>Construyo servicios robustos y escribo sobre las decisiones tecnicas detras de ellos.</h1>
          <p className="hero-copy">
            Este blog documenta casos reales, patrones de arquitectura y aprendizajes de backend engineering para que recruiters
            y equipos tecnicos puedan evaluar mi forma de pensar, no solo mi stack.
          </p>
          <div className="hero-actions">
            <a className="button primary" href="#articulos">
              Ver articulos
              <ArrowRight size={18} />
            </a>
            <a className="button secondary" href="#proyectos">
              Revisar proyectos
            </a>
          </div>
        </div>
        <ProfileSummary />
      </section>

      <section className="section band">
        <div className="section-heading">
          <p className="eyebrow">Enfoque profesional</p>
          <h2>Senales claras para equipos que contratan backend.</h2>
        </div>
        <div className="strength-grid">
          {strengths.map(({ icon: Icon, title, text }) => (
            <article className="strength-card" key={title}>
              <Icon size={22} />
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section" id="articulos">
        <div className="section-heading">
          <p className="eyebrow">Blog tecnico</p>
          <h2>Articulos destacados.</h2>
        </div>
        <PostList />
      </section>

      <section className="section band" id="proyectos">
        <div className="section-heading">
          <p className="eyebrow">Portafolio</p>
          <h2>Proyectos que muestran criterio de ingenieria.</h2>
        </div>
        <div className="project-grid">
          {projects.map((project) => (
            <article className="project-card" key={project.name}>
              <div>
                <span>{project.type}</span>
                <h3>{project.name}</h3>
                <p>{project.summary}</p>
              </div>
              <ul>
                {project.highlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="contact-section" id="contacto">
        <div className="contact-copy">
          <p className="eyebrow">Disponible para oportunidades</p>
          <h2>Hablemos de backend, cloud y productos que necesitan crecer con orden.</h2>
          <p>
            Si tienes una oportunidad, colaboracion o proyecto backend, dejame tus datos y construimos
            una primera conversacion con contexto.
          </p>
        </div>
        <ContactForm />
      </section>

      <footer>
        <span>Backend Notes</span>
        <span>
          <GitBranch size={16} /> CI/CD ready
        </span>
        <span>
          <Gauge size={16} /> Static first
        </span>
      </footer>
    </>
  );
}
